<template>
  <div class="position-r box">
    <div class="index-banner" :style="{ backgroundImage: 'url(' + topBg.advUrl + ')' }" @click="goToUrl">
      <div class="f24 fw">欢迎使用</div>
      <div class="f24 fw"><span class="color-09">爱格汇</span>共享{{devTypeName}}</div>
      <div class="pt5 flex-fs">
        <div class="mr8 photo-icon">
          <img :src="headPhoto" alt="" class="head-img" />
        </div>
        <span>{{ userName }}</span>
      </div>
    </div>
    <div class="flexJC p15" style="margin-top: -80px">
      <div class="" v-show="isMz == false">
        <!--租借-->
        <div class="content-box" v-show="isNormal == 1 && isBackBed == false">
          <div class="flexJC alignItem">
            <div class="flex-fs fw">
              <i class="icon-con icon_lb"></i>
              <span class="f16 color-3 mt-3">{{
                filterFun(cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.placeName)
              }}</span>
            </div>
            <h3 class="f20 color-3 pt10">
              可用{{devTypeName}}<span class="color-09">{{ number }}</span>台<span v-if="number == 0">请扫其它设备</span>
            </h3>
            <div class="wheelchair-img pt10 pb15">
              <img src="../../static/images/wheelchair.png" alt="" />
            </div>
            <div class="flexJC text-left">
              <div>
                <div style="float: left; width: 66%" align="left">
                  <h4 class="pb10">计费规则</h4>
                </div>
                <div style="float: left; width: 34%" align="right">
                  <a href="https://mp.weixin.qq.com/s/of5nX3s1TKvxMCyHfP1K6w" style="margin-right: -20px" class="btn btn-lx-big mb10 btn-width">关注公众号</a>
                </div>
              </div>

              <p v-if="cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.placeNo==='001031'" class="pt5 color-6 f12">
                包夜时间：（晚上21：00到第二天早上7：30）5元/次，非包夜时间：每天提供5分钟免费试用，超出免费时间后每小时收费1元，不足1小时按照1小时计算，日封顶20元。
              </p>

              <p v-else class="color-09 pt5">
                {{ cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.chargeMoney }}元 / {{
                  cabinetInfo && cabinetInfo.cabinet.chargeType === "HOUR"
                    ? (cabinetInfo && cabinetInfo.cabinet && parseInt(cabinetInfo.cabinet.capaUnit)> 1 ? cabinetInfo.cabinet.capaUnit:'') + "小时"
                    : cabinetInfo && cabinetInfo.cabinet.chargeType === "DAY"
                    ? (cabinetInfo && cabinetInfo.cabinet && parseInt(cabinetInfo.cabinet.capaUnit)> 1 ? cabinetInfo.cabinet.capaUnit:'') + "天"
                    : (cabinetInfo && cabinetInfo.cabinet && parseInt(cabinetInfo.cabinet.capaUnit)> 1 ? cabinetInfo.cabinet.capaUnit:'') + "分钟"
                }}
                <span style="color:red;">租借{{ cabinetInfo && cabinetInfo.cabinet ? cabinetInfo.cabinet.freeTime:'' }}分钟内免费</span>，日封顶{{
                  cabinetInfo && cabinetInfo.cabinet 
                    ? cabinetInfo.cabinet.dayMoneyMax
                    : 0
                }}元，总封顶{{
                  cabinetInfo && cabinetInfo.cabinet ? cabinetInfo.cabinet.depositMoney : 0
                }}元，{{
                  cabinetInfo && cabinetInfo.cabinet&&cabinetInfo.cabinet.freeTimeFlag==1 ? '计费时间不含免费时间' : '计费时间含免费时间'
                }}
              </p>
              <p class="pt5 color-6 f12">支持免押租借</p>
            </div>
            <div class="mt36 flexJC alignItem" style="width: 80%">
              <a class="btn-lx btn-lx-big mb10" :disabled="number == 0 || isDisabled == true" :class=" number == 0 || isDisabled === true ? 'unSubmit' : 'btn-width'" v-if="isNormal == 1 && isBackBed == false" @click="postFreeOrder">立即租借</a>
              <button class="btn-lx btn-lx-big mb10" @click="backToIndex" v-if="flag">返回首页</button>
              <a class="btn-lx btn-lx-big mb10 btn-width" @click="paySucceeded" v-if="isNormal != 1 || isBackBed && !isDisabled">已支付</a>
            </div>
            <div class="flexJC alignItem pb10" v-if="isNormal == 1 && isBackBed == false">
              <div class="flex-fs f12" style="height: 15px">
                <img class="zff-logo" src="../assets/zfflogo.png" />
                &nbsp;
                <div class="zff-text">微信支付分 | 550分及以上优享</div>
              </div>
            </div>
            <div class="flexJC alignItem pt20">
              <router-link tag="div" to="/agreement" class="f10 color-9 mr10">用户协议</router-link>
            </div>
          </div>
        </div>

        <!--设备异常-->
        <div class="content-box" v-show="isNormal == 0">
          <div class="flexJC alignItem text-over">
            <div class="flex-fs fw">
              <i class="icon-con icon_lb"></i>
              <span class="f16 color-3 text-over mt-3">{{
                placeName
              }}</span>
            </div>
            <div class="pt18">
              <div class="noNormal">
                <img src="../../static/images/icon_noNarmal.png" alt="" />
                <a href="https://mp.weixin.qq.com/s/of5nX3s1TKvxMCyHfP1K6w" style="
                    margin-right: -20px;
                    width: 50%;
                    margin-bottom: 40%;
                    margin-left: 10px;
                    font-size: 14px;
                    padding: 10px;
                  " class="btn btn-lx-big mb10 btn-width">关注公众号</a>
              </div>
              <div class="f16 color-9 pt10" style="width:100%;white-space:normal;">
                 {{ errorMessage }}
              </div>
              <div class="f16 color-9 pt10">
                <p>为您带来的不便我们深表歉意</p>
              </div>
            </div>
          </div>
          <div class="flex mt36">
            <a href="tel:400-688-9528" class="btn-lx btn-lx-width">联系客服</a>
          </div>
        </div>
      </div>
    </div>
    <div class="p15" v-show="isBackBed == false">
      <div class="banner">
        <mt-swipe :auto="8000">
          <mt-swipe-item>
            <div class="cabinet-box flexJC alignItem cabinet-content" @click="goToUrl">
              <div class="fw f20">
                <span class="ml10">押金归还即退</span>
              </div>
              <div class="f14">
                预收金额<span class="f14 color-09">{{
                  cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.depositMoney
                    ? cabinetInfo.cabinet.depositMoney
                    : 0
                }}</span>元<span>微信支付分550分以上扫码免押</span>
              </div>
            </div>
          </mt-swipe-item>
          <mt-swipe-item v-for="item in bannerList" :key="item.advNo">
            <a class="displsy-block banner-a" @click="goToNewUrl(item.outerUrl)"><img :src="item.advUrl" alt="" class="border-radius" /></a>
          </mt-swipe-item>
        </mt-swipe>
      </div>
    </div>
    <div class="p15">
    </div>
    <!--弹框-->
    <div class="shade" v-show="hasMore">
      <div class="flexJC alignItem showLoading">
        <img src="../../static/images/Spinner_1.gif" alt="" class="icon_loading" />
      </div>
    </div>
    <div v-html="alipayWap" ref="alipayWap"></div>
    <audio id="audio_door_opened" src="https://www.aigehui028.com/static/mp/audios/wh-door-opened.mp3" width="1" height="1" preload></audio>
  </div>
</template>

<script>
import wxServ from "../service/wxServ";
import cache from "../service/cacheServ";
import cabinetServ from "../service/cabinetServ";
import mintUi from "../lib/mint-ui";
import moment from "moment";
import log from '../lib/log'
import preventBack from 'vue-prevent-browser-back'

export default {
  mixins: [preventBack], //禁止返回上一页
  data() {
    return {
      flag: false,
      queryCount: 0,
      headPhoto: "/static/images/touxiang@2x.png",
      userName: "",
      isLoading: true,
      isNormal: null,
      cabinetInfo: null,
      number: null,
      qrCode: null,
      bedNo: null,
      hasMore: false,
      isBackBed: null, // 是否还床？
      list: null,
      wxId: null,
      giveBackList: null,
      alipayWap: null,
      isDisabled: false,
      bannerList: [],
      timerList: [],
      isFree: null,
      isMz: null,
      isYajin: false,
      checkedValue: true,
      topBg: {
        advUrl: "",
        outerUrl: null,
      },
      wsPayResult: "",
      getFreeLeaseOrderResult: "",
      errorMessage:"",
      placeName:"",
    };
  },
  computed: {
    devTypeName() {
      try {
        if (this.cabinetInfo.cabinet.cabinetNo.endsWith('-01')) return '陪护床'
        else
          if (this.cabinetInfo.cabinet.cabinetNo.endsWith('-03')) return '床头柜'
          else return '轮椅'
      } catch (err) {
        return '轮椅'
      }
    }
  },
  async created() {
    let qrCode = this.$route.query.qrcode;
    console.log("qrCode:" + this.$route.query.qrcode);
    this.qrCode = qrCode;
    this.bedNo = this.$route.query.bedNo;
    //await this.getCabinetSta(qrCode);
//     let userInfo={city: "",
// country: "",
// createTime: "2022-12-30 10:30:54",
// customerName: "颠覆了人生观",
// customerNo: "CSwbMf626848",
// fromClient: 1,
// headImgUrl: "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKYpzXIuS06EbKEEE3O0aWI2WxCDibsic1th35icZYlxjdLYRSiaGvyxLHrNX2StcEgicrMwpgvphRpHFQ/132",
// id: 26911,
// openId: "og9Am5wCEcCOSyAJqOdvLotYxDCY",
// phoneNum: null,
// province: "",
// sex: 0,
// status: "0",
// subscribe: null,
// subscribeTime: null,
// updateTime: "2022-12-30 10:30:54",
// wxOpenId: null,
// zfbOpenId: null,}
    let userInfo = cache.get("user");
    // cache.set("user",userInfo,true);
    if (userInfo && userInfo.openId) {
      this.userName = userInfo.customerName;
      this.headPhoto = userInfo.headImgUrl
        ? userInfo.headImgUrl
        : "/static/images/touxiang@2x.png";
      this.wxConfigJssdk(userInfo.openId);
      //await this.getIsBedFun(userInfo.openId);
      this.wxId = userInfo.openId;
      //await this.getCabinetSta(qrCode);
      this.queryCabinetOrderInfo(this.wxId,qrCode,this.bedNo)
      this.getBannerList("HOME");
      this.getBannerList("HOMETOP");
      this.BackIndexBtn()
    }
  },
  methods: {
    backToIndex() {
      wx.miniProgram.redirectTo({
        url: '/pages/index/index'
      })
    },
    BackIndexBtn() {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          this.flag=true
        } else {
          this.flag=false
        }
      })
    },
    queryCabinetOrderInfo(customerWxId,qrCode,bedNo){
      this.isBackBed = false;
      this.isMz = false;
      let that = this;
      mintUi.Indicator.open({
    	   text: '加载中...',
    	   spinnerType: 'fading-circle',
       });
      cabinetServ.queryCabinetOrderInfo(customerWxId,qrCode,bedNo).then(function (res) {
            mintUi.Indicator.close();
            if (res.code === "200") {
              that.cabinetInfo = res.data;
              if (res.data.bedStructList) {
                let newList = res.data.bedStructList.filter((item,index) => item.status === 1&&res.data.doorStatus[index]===1);
                that.number = newList?newList.length:0;
              }
              that.isNormal = 1;
              cache.set("cabinetInfo", res.data, true);
              // that.getTimeList(that.qrCode);
            }else{
              that.number = 0;
              that.isNormal = 0;
              that.errorMessage=res.message||"服务器开小差，请稍后再试";
              that.placeName = res.data || ""
              cache.set("cabinetInfo", {}, true);
              that.queryCount++;
              if(that.queryCount<6){
                setTimeout(() => {
                  that.queryCabinetOrderInfo(customerWxId,qrCode,bedNo)
                }, 5000*that.queryCount);
              }
            }
      })
    },
    dateFormatter(time) {
      let datetime = time;
      if (datetime == undefined) {
        return "";
      }
      return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
    },

    goToUrl() {
      if (this.topBg.outerUrl) {
        window.location.href = this.topBg.outerUrl;
      } else {
        window.location.href = "https://www.aigehui028.com/";
      }
    },
    filterFun: function (value) {
      if (value && value.length > 13) {
        value = value.substring(0, 13) + "...";
      }
      return value;
    },
    // 获取广告
    getBannerList(position) {
      wxServ.getBanner(position).then((res) => {
        if (res.code === "200") {
          if (position == "HOME") {
            this.bannerList = res.data;
          } else if (position == "HOMETOP") {
            if (res.data && res.data.length > 0) {
              this.topBg = res.data[0];
            }
          }
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    goToNewUrl(url) {
      if (url) {
        window.location.href = url;
      } else {
        return false;
      }
    },

    formatDate(datetime, fmt = "yyyy/MM/dd hh:mm:ss") {
      let date = new Date();
      date.setTime(Date.parse(datetime));
      const o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        "S+": date.getMilliseconds(), // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          `${date.getFullYear()}`.substr(4 - RegExp.$1.length)
        );
      }
      for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
          ); //eslint-disable-line
        }
      }
      return fmt;
    },
    // 时间戳
    getTimesTamp(time) {
      return new Date(time).getTime();
    },
    //获取微信jssdk
    wxConfigJssdk(openId) {
      wxServ.configJssdk(openId);
    },
    compareVersion(v1, v2) {
      v1 = v1.split(".");
      v2 = v2.split(".");
      const len = Math.max(v1.length, v2.length);

      while (v1.length < len) {
        v1.push("0");
      }
      while (v2.length < len) {
        v2.push("0");
      }

      for (let i = 0; i < len; i++) {
        const num1 = parseInt(v1[i]);
        const num2 = parseInt(v2[i]);

        if (num1 > num2) {
          return 1;
        } else if (num1 < num2) {
          return -1;
        }
      }

      return 0;
    },
    changeInput(e) {
      console.log(e.target.checked);
      this.checkedValue = e.target.checked;
    },
    postFreeOrder() {
      // disabled
      if (this.number == 0 || this.isDisabled == true) return;
      var that = this;
      if (this.checkedValue == false) {
        mintUi.Toast({
          message: "请勾选同意《委托扣款授权书》",
          position: "bottom",
        });
        return;
      }
      this.isFree = true;
      this.isDisabled = true;
      wxServ.getFreeLeaseOrder(this.wxId, this.qrCode, this.bedNo).then((res) => {
        this.isFree = false;
        if (res.code == "200") {
          this.getFreeLeaseOrderResult = res.data;
          var data = res.data;
          wx.ready(function () {
            let wechatInfo = navigator.userAgent.match(
              /MicroMessenger\/([\d\.]+)/i
            );
            let wechatVersion = wechatInfo[1];
            wx.checkJsApi({
              jsApiList: ["openBusinessView"], // 需要检测的JS接口列表
              success: function (res) {
                if (res.checkResult.openBusinessView) {
                  wx.invoke(
                    "openBusinessView",
                    {
                      businessType: "wxpayScoreUse",
                      queryString: `mch_id=${data.mch_id}&package=${data.package}&timestamp=${data.timestamp}&nonce_str=${data.nonce_str}&sign_type=${data.sign_type}&sign=${data.sign}`,
                    },
                    function (res) {
                      // 从支付分返回时会执行这个回调函数
                      that.wxPayResult = res;

                      //log.info({ url: window.location.href, loc: 'openBusinessView', contents: { qrCode: this.qrCode, openBusinessView: res }, qrcode: 1171 === +that.qrCode })
                      // 从支付分返回时会执行这个回调函数
                      // let samplePayResult = { 'loc': 'openBusinessView', 'contents': { 'openBusinessView': { 'extraData': '{"query_id":"AAQTnZoAAAABAAAAAADNR1Q_-k3hG5POjr1CYyAAAABcwQVtru-5k9MmEOZJ_Pv_Nq7Cw56dNKKN5EjZKnt5jbjJ0bdMUoiUK1mof_WSZOoUo2XSheodqBnxVQyxxNhdbE1qEnKV54NboKBBwKWCijchQD-m-UNKau_gxnBqgjjNCN-86UozKoZdCbFl_Pqtwr_wpUFlSBkyrV7-oa-MV1-vQlb2oBs-639XdOSnn9Pjo9OgxksNx-eCdwdLOI__rJXL","appid":"wxd8f3793ea3b935b8"}', 'err_msg': 'openBusinessView:ok', 'err_code': '0' } } }
                      that.isDisabled = false;
                      if (0 === +res.err_code) {
                        this.isYajin = false;
                        setTimeout(function () {
                          
                        if (typeof res.extraData === typeof '') res.extraData = JSON.parse(res.extraData)
                        if (Boolean(res.extraData) && Boolean(res.extraData.query_id)) {
                            that.wxPayResult = res;
                                  let subDir = '';
                                  if (window.location.href.includes('testing-bedoa')) subDir = '/testing-bedoa';
                                  else if (window.location.href.includes('testing')) {
                                    subDir = '/testing'
                                  }

                                  let targetPage = 'paySuccess';

                            // https://tswap.aigehui028.com/#/Index?qrcode=1171&bedNo=1

                                  let targetUrl = `${window.location.origin}${subDir}/#/${targetPage}?qrCode=${that.qrCode}&orderNo=${data.orderNo}&bedNo=${that.bedNo}`;

                            //log.info({ url: window.location.href, loc: 'openBusinessView', contents: { loc: 'openBusinessViewSucceeded', contents: targetUrl }, qrcode: 1171 === +this.qrCode })

                                  window.location.href = targetUrl;
                                }
                        }, 300);
                      } else {
                        // 返回失败
                        this.isYajin = true;
                      }
                    }
                  );
                }
              }
            });
          });
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
            duration: 4000,
          });
          setTimeout(() => {
            that.isDisabled = false;
          }, 4000);
        }
      });
    },
    toUrlFun() {
      this.$router.push({ path: "/expenses", query: { qrCode: this.qrCode } });
    },
    paySucceeded() {
      let media = document.getElementById("audio_door_opened");
      // media.src = "https://www.aigehui028.com/static/mp/audios/wh-door-opened.aac"
      media.play();
      log.info({ url: window.location.href, loc: 'openBusinessView', contents: { wxPayResult: this.wxPayResult }, qrcode: 1171 === +this.qrCode })
      setTimeout(() => {
        if (typeof this.wxPayResult.extraData === typeof '') this.wxPayResult.extraData = JSON.parse(res.extraData)

        if (Boolean(this.wxPayResult.extraData.query_id)) {
          window.location.href =
            window.location.origin +
            "/#/openSuccess?qrCode=" +
            this.qrCode +
            "&orderNo=" +
            this.getFreeLeaseOrderResult.orderNo;
        }
      }, 2000);
    }
  },
  mounted() {
    // this.getCabinetSta(this.qrCode)
  },
};
</script>

<style lang="less" scoped>
@import "../less/_var.less";
@import "../less/index.less";

.banner-position {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 145px;
  z-index: -1;
}
.banner-position img {
  width: 100%;
  height: 100%;
}
.index-banner {
  padding: 26px 25px 0 25px;
  text-align: left;
  color: #fff;
  background-size: 100% 100%;
  height: 214px;
}
.pt5 {
  padding-top: 5px;
}
.loadingImg {
  width: 100px;
  height: 100px;
}
.loading-con {
  width: 70%;
  margin-left: -35%;
}
.photo-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
}
.photo-icon img {
  width: 100%;
  height: 100%;
}
.banner {
  height: 120px;
}
.banner img {
  width: 100%;
  height: 100%;
}
.userInfo {
  position: absolute;
  left: 90px;
  top: 15px;
  right: 16px;
}
.icon_lb {
  background: url("../../static/images/icon_position.png") no-repeat;
  background-size: 100% 100%;
  width: 14px;
  height: 16px;
}
.wheelchair-img {
  width: 177px;
  height: 177px;
}
.wheelchair-img img {
  // width: 100%;
  width: auto;
  height: 100%;
  margin: auto;
}
.icon-fy {
  background: url("../../static/images/icon_fy.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.mt-3 {
  margin-top: -2px;
}
.icon-sb {
  background: url("../../static/images/icon_sb.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.icon_loading {
  width: 60px;
  height: 60px;
}
.head-img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
}
.unSubmit {
  background-color: #808080;
  color: #fff;
  border-color: #808080;
}
.zff-logo {
  height: 100%;
}
.zff-text {
  color: #666;
  font-family: PingFang;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue